!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if (window.define)
		define('hotels/checkAvailability',['libs/ct_view'], module)
	else
	//>>excludeEnd("requireTmpl");
		module(CT.View)

}('chkAvail', function(View) {

	var chkAvail = {
		events : {
			'click button.chkAvail': 'initFunc'
		}
	}

	chkAvail.initFunc = function() {
		CT.beforeChkAvailFilters[CT.settings.currentTab] = [CT.applyTheseFilters,0];

		$('.flushMessage').hide();
		var cTab = $("#ResultContainer_"+CT.settings.currentTab);
		var mEle = $(".modify");

		var modifyOffest	= mEle.offset();
		var modfyWidth 		= mEle.width();
		var mainDivOffest 	= cTab.offset();
		var mainDivheight 	= cTab.height();

		//scroll handler
		$(window).scroll(function (){
			if(CT.checkAvailFlag[CT.settings.currentTab]){
				mainDivOffest = $("#ResultContainer_"+CT.settings.currentTab).offset();

				if(window.scrollY > $("#PrimaryIconNavigation").height()+13){
					mEle.css({"position":"absolute","z-index":11,"width":modfyWidth,"background-color":"#f5f5f5","top":window.scrollY+"px"});
					cTab.css({"margin-top":(mEle.height() + 30)+"px"});
				}else{
					mEle.css({"position":"static","z-index":0});
					cTab.css({"margin-top":"0px"});
				}
				$('.blockDiv').css({'top': (mainDivOffest.top-window.scrollY)+'px'});
			}
		});

		window.scroll(scrollX,scrollX+1);//To trigger window.scroll event.

		//blocking the results
		cTab.append("<div class='blockDiv' style='width:100%;height:"+mainDivheight+"px;position:fixed;background:#000;opacity:0.7;top:"+(mainDivOffest.top-window.scrollY)+"px'></div>")

		//Making modify button text from search to Check Availablity
		mEle.find("button").html(CT.messages.checkAvailability).css({"width":"auto"});
	}

	CT.subscribe('initChkavail', function() {
		chkAvail.$el = $("#ResultContainer_"+CT.settings.currentTab).find(".listView");
		var chkavailView = View(chkAvail);
		//CT.cache.views[CT.settings.currentTab].chkv = chkavailView;
	});

	return chkAvail;

});

